import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushArticlesBlogB2b } from '@components/push-articles-blog-b2b/models';
import { ButtonComponent } from '@shared/components/button';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-push-articles-blog-b2b',
  templateUrl: './push-articles-blog-b2b.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OptionCardComponent, SvgComponent, TitleComponent, RouterLink, ButtonComponent],
})
export class PushArticlesBlogB2bComponent extends AbstractDynamicComponent<PushArticlesBlogB2b> {}
